<template>
  <div>
    <!-- Pregunta simple ordenada con la clase row -->
    <v-radio-group row v-if="row">
      <v-radio
        v-for="answer in options"
        :key="answer.id"
        :label="answer.title"
        :value="answer.title"
        color="blue darken-4"
        :error-messages="radioErrors"
        v-model="answer.title"
        @change="setAnswer(answer.title)"
      ></v-radio>
    </v-radio-group>
    <!-- Pregunta simple ordenada sin la clase row -->
    <v-radio-group v-else>
      <v-radio
        v-for="answer in options"
        :key="answer.id"
        :label="answer.title"
        :value="answer.title"
        color="blue darken-4"
        :error-messages="radioErrors"
        v-model="answer.title"
        @change="setAnswer(answer.title)"
      ></v-radio>
    </v-radio-group>
    <!-- Escala lineal ordenada con row -->
    <v-radio-group row v-if="lineal">
      <v-radio
        v-for="(option, index) in 10"
        :key="index"
        :label="(index + 1).toString()"
        :value="index + 1"
        color="blue darken-4"
        :data-question="question.id"
        @change="setAnswer(index + 1, question)"
      ></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      answer: {
        title: ""
      }
    };
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    row: {
      type: Boolean,
      required: false
    },
    lineal: {
      type: Boolean,
      required: false
    },
    options: {
      type: Array,
      required: false
    }
  },
  validations: {
    answer: {
      title: {
        required
      }
    }
  },
  computed: {
    radioErrors() {
      const errors = [];
      if (!this.$v.answer.$dirty) return errors;
      !this.$v.answer.required && errors.push("Este campo es requerido.");
      return errors;
    }
  },
  methods: {
    setAnswer(answer) {
      this.$v.answer.$touch();
      this.$emit("get_answer", {
        option: answer,
        question: this.question
      });
    },
  }
};
</script>